<template>
    <v-row
        class="mb-6"
        justify="center"
        no-gutters
    >
        <v-col
            xs="10"
            sm="8"
            md="6"
            lg="4"
        >
            <div class="d-flex justify-center">
                <v-chip
                    pill
                    class="mr-3"
                >
                    <router-link
                        :to="''"
                        style="text-decoration: none;"
                    >
                        Lecteur
                    </router-link>
                </v-chip>
                <!-------------------------- DIALOG ---------------------------->
                <v-dialog
                    v-model="dialog"
                    persistent
                    max-width="600"
                    class="ml-3"
                >
                    <template #activator="{ on, attrs }">
                        <v-chip
                            v-bind="attrs"
                            v-on="on"
                        >
                            Favoris
                        </v-chip>
                    </template>
                    <v-card>
                        <v-card-title class="headline">
                            Liste de favoris
                        </v-card-title>
                        <v-card-text>
                            <v-card
                                class="song pa-3"
                                v-for="(song, index) in favoritelist"
                                :key="index"
                            >
                                <v-icon
                                    small
                                    class="play mr-2"
                                >
                                    mdi-play
                                </v-icon>
                                <img
                                    class="img"
                                    :src="song.imagePath"
                                    :alt="song.name"
                                >
                                <span class="title-song">
                                    <b>{{ song.name }}</b> - {{ song.artist }}
                                </span>
                                <v-icon
                                    small
                                    class="delete"
                                    @click="remove(index)"
                                >
                                    mdi-delete
                                </v-icon>
                            </v-card>
                            <p v-if="!favoritelist.length">
                                Votre liste de favoris est vide !
                            </p>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn
                                text
                                @click="dialog = false"
                            >
                                Fermer
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'FavoriteChip',
    props: {
        'favoritelist': {
            type: Array,
            required: false,
            default: () => [],
        }
    },
    emits: ['remove'],
    data() {
        return {
            dialog: false,
        };
    },
    methods: {
        remove: function (index) {
            this.$emit('remove', index);
        }
    },
};
</script>

<style lang="scss">
.delete {
    float: right;
}
</style>
